import React, { useState, useEffect } from "react";
import {
  AppBar,
  useNotify,
  useTheme,
  LocalesMenuButton,
  LoadingIndicator,
} from "react-admin";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import Logo from "./Logo";
import ExpiryText from "./ExpiryText";
// import { store } from "../../store.js";
import MyUserMenu from "./MyUserMenu";
import {
  permissions,
  requiredFields,
  useCheckSubscribedApps,
  useDebugFbToken,
} from "./TokenValidator";
import AutoLogout from "./AutoLogout";
import LiveVideoChecker from "./LiveVideoChecker";
import { IconButton } from "@mui/material";
import { LightMode } from "@mui/icons-material";
import { DarkMode } from "@mui/icons-material";

const Spacer = styled("span")({
  flex: 1,
});

const myAlert = () =>
  alert(
    `Facebook permissions expired. Please logout Boxify, then "LOGIN WITH FACEBOOK".`
  );

const ThemeToggler = () => {
  const [theme, setTheme] = useTheme();

  // On mount → check localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme && savedTheme !== theme) {
      setTheme(savedTheme);
    } else if (!savedTheme && theme === "light") {
      // default to light if nothing is stored
      localStorage.setItem("theme", "light");
    }
  }, []); // run once on mount

  // Whenever theme changes → update localStorage
  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <IconButton
      color="inherit"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
    >
      {theme === "dark" ? <LightMode /> : <DarkMode />}
    </IconButton>
  );
};
const MyAppBar = (props) => {
  const notify = useNotify();
  // const { state } = useContext(store);

  const [isSubscribed, setIsSubscribed] = useState(true);
  const [isFbTokenValid, setIsFbTokenValid] = useState(true);

  const { data: subscribeApps } = useCheckSubscribedApps(undefined, {
    onSuccess: (data) => {
      if (data && data.data && data.data[0] && data.data[0].subscribed_fields) {
        const foundFields = requiredFields.filter(
          (f) => data.data[0].subscribed_fields.indexOf(f) > -1
        );
        if (foundFields.length < requiredFields.length) {
          setIsSubscribed(false);
          myAlert();
          return;
        } else {
          setIsSubscribed(true);
        }
      } else {
        setIsSubscribed(false);
        myAlert();
      }
    },
  });

  const { data: fBTokenStatus } = useDebugFbToken(undefined, {
    onSuccess: (data) => {
      if (!data.data.is_valid) {
        myAlert();
        setIsFbTokenValid(false);
        return;
      }
      const missingPermissions = permissions.filter(
        (p) => data.data.scopes.indexOf(p) === -1
      );
      if (missingPermissions.length > 0) {
        notify(
          `Please perform Login with Facebook to get missing permissions: ${missingPermissions.join(
            ","
          )}`,
          {
            type: "warning",
            autoHideDuration: 10000,
          }
        );
      }
      setIsFbTokenValid(true);
    },
  });

  if (!isFbTokenValid || !isSubscribed) {
    return (
      <AppBar
        sx={{ backgroundColor: "red" }}
        {...props}
        userMenu={<MyUserMenu />}
      >
        <Typography
          variant="h6"
          color="inherit"
          sx={{
            flex: 1,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
          id="react-admin-title"
        />
        <Typography variant="h6" color="inherit" id="react-admin-title">
          {`Facebook permissions expired. Please logout Boxify, then "LOGIN WITH FACEBOOK".`}
        </Typography>
        <AutoLogout />
        {/* {process.env.REACT_APP_LOAD_FC === "TRUE" && <FreshChatWidget />} */}
      </AppBar>
    );
  }

  return (
    <AppBar
      {...props}
      userMenu={<MyUserMenu />}
      toolbar={
        <>
          {/* <LocalesMenuButton /> */}
          <LocalesMenuButton />
          <ThemeToggler />
          <LoadingIndicator />
        </>
      }
    >
      <Typography
        variant="h6"
        color="inherit"
        sx={{
          flex: 1,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
        id="react-admin-title"
      />
      <Logo />
      <Spacer />
      <ExpiryText />
      <LiveVideoChecker />
      <AutoLogout />
      {/* {process.env.REACT_APP_LOAD_FC === "TRUE" && <FreshChatWidget />} */}
      {/* {window.fcWidget && window.fcWidget.isOpen && <DraggableWidget />} */}
    </AppBar>
  );
};

export default MyAppBar;
